// export const baseURL = process.env.NODE_ENV === 'development' ? 'http://localhost:80001/' : 'https://prd-risk-01.esurv.co.uk/api/';


import axios from 'axios';

import { getAuthToken, clearAuthToken } from './auth';

// export const baseURL = process.env.NODE_ENV === 'development' ? 'http://localhost:8001/' : 'http://dev-rpalinux-01.esurv.co.uk:8001/';

export const baseURL = process.env.REACT_APP_BASE_URL;


const axiosInstance = axios.create({
    baseURL: baseURL,
    headers: {
        'Authorization': `Token ${getAuthToken()}`,
        'Content-Type': 'application/json',
        'accept': 'application/json'
    }
});

axiosInstance.interceptors.response.use(
    response => response,
    async error => {
        const originalRequest = error.config;

        // Prevent infinite loops
        if (error.response.status === 401) {
            window.location.href = '/login/';
            return Promise.reject(error);
        }
        if (error.response.status === 403) {
            clearAuthToken();
            window.location.href = '/login/';
            return Promise.reject(error);
        }

        // specific error handling done elsewhere
        return Promise.reject(error);
    }
);

export default axiosInstance